import React from 'react';

const AreYouMissingOut = () => (
  <section id="two" className="main style3">
    <div className="grid-wrapper">
      <div className="col-12">
        <header className="major align-center">
          <h2>Feel like you&apos;re missing out?</h2>
        </header>
      </div>
      <div className="col-6">
        <ul className="align-left" style={{ marginBottom: 0 }}>
          <li>Do you long for something new in your relationships?</li>
          <li>Does work feel like the same thing over and over again?</li>
          <li>Have you lost your passion?</li>
          <li>Do you feel stuck?</li>
        </ul>
      </div>
      <div className="col-6">
        <ul className="align-left">
          <li>Do you wish you were more creative?</li>
          <li>Do you regularly feel irritated or angry?</li>
          <li>Are you struggling to get up in the morning?</li>
          <li>Are you drifting more than living?</li>
        </ul>
      </div>
    </div>
  </section>
);

export default AreYouMissingOut;